//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    extraPadding: {
      type: Boolean,
      value: false,
    },
    alternateImages: {
      required: false,
      default: false,
    },
    showPhotos: {
      required: false,
      default: false,
    },
    showEPPhotos: {
      required: false,
      default: false,
    },
    extraClass: {
      required: false,
      type: String,
    },
    title: {
      type: String,
      default:
        "Thousands of people – from business owners to attorneys – use LegalNature every day to manage their business and personal affairs.",
    },
    dataTag: {
      required: false,
      default: "",
    },
    animate: {
      required: false,
      default: false,
    },
  },
};
